module.exports = __webpack_public_path__ + "img/concept5.02bd9ed.jpg";